/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_List_Catalog_RegenerateInputs */

const cs_property_list_catalog_regenerate = /** @type {(inputs: Property_List_Catalog_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat katalogové PDF znovu`)
};

const en_property_list_catalog_regenerate = /** @type {(inputs: Property_List_Catalog_RegenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regenerate catalog PDF`)
};

/**
* | output |
* | --- |
* | "Regenerate catalog PDF" |
*
* @param {Property_List_Catalog_RegenerateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_list_catalog_regenerate = /** @type {((inputs?: Property_List_Catalog_RegenerateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_List_Catalog_RegenerateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_list_catalog_regenerate(inputs)
	return cs_property_list_catalog_regenerate(inputs)
});